export const GET_ALL_TRANSACCIONES_PAGINATED = `
  query getAllTransaccionPaginated($limit: Float, $nextToken: String) {
    getAllTransaccionPaginated(limit: $limit, nextToken: $nextToken) {
      items {
        id
        banco
        cuenta
        fecha
        fechaValuta
        descripcion
        tipo
        monto
        saldo
        operacion
        horaOperacion
        usuario
        referencia
        estado
        createdAt
        updatedAt
        IdOrder
      }
      hasMore
      nextToken
    }
  }
`;
